import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';

function LiveCampaignStatCard(props) {
  return (
    <div className="col-span-full sm:col-span-6 xl:col-span-3 bg-white shadow-1 rounded-sm border border-slate-200">
      <div className="flex flex-col h-full text-center p-5">
        <div className="grow mb-1">
          <div className="inline-flex text-2xl justify-center items-center w-12 h-12 bg-slate-100 rounded-full mb-2">
            {props.icon}
          </div>
          {props.stat > -1 ?
              <h3 className="text-2xl text-slate-800 font-semibold mb-1"><CountUp end={props.stat}/></h3> :
              <div className="m-auto text-center mb-2">
                <svg className="animate-spin h-5 w-full" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="45" stroke="#0F172A" strokeWidth="6" fill="transparent" strokeLinecap="round"
                          strokeDasharray="283" strokeDashoffset="75"/>
                </svg>
              </div>
          }
        </div>
        <div>
          <div className="text-sm font-medium text-pink-500">{props.name}</div>
        </div>
      </div>
    </div>
  );
}

export default LiveCampaignStatCard;